/* @flow weak */
import React from 'react';
import Form from 'components/Form.jsx';
import Button from 'components/Button.jsx';
import BoxBody from 'components/BoxBody.jsx';
import FormInput from 'components/FormInput.jsx';
import humanparser from 'humanparser';
import UserActions from 'user/UserActions';
import CurrentUser from 'auth/CurrentUser';
import AuthActions from 'auth/AuthActions';
import DialogContent from 'components/DialogContent.jsx';
import ToastActions from 'actions/ToastActions';

const JoinEmailAccountUpgradeForm = React.createClass({
  propTypes: {
    onDone: React.PropTypes.func.isRequired,
  },

  getInitialState() {
    return {
      enabled: false,
    };
  },

  handleSubmit(attrs) {
    const onFailure = () => {
      ToastActions.showDefaultErrorToast();
    };

    const onUpdateSuccess = () => {
      AuthActions
        .signIn(CurrentUser.getUser().getEmail(), attrs.password)
        .then(this.props.onDone, onFailure);
    };

    const human = humanparser.parseName(attrs.full_name);

    UserActions.update({
      prefix: human.salutation,
      first_name: human.firstName,
      last_name: human.lastName,
      password: attrs.password,
    }).then(onUpdateSuccess, onFailure);
  },

  render() {
    return (
      <DialogContent
        size="small"
        title={'Complete your account'}>
        <BoxBody divided>
          <Form
            onSubmit={this.handleSubmit}
            onValid={() => this.setState({ enabled: true })}
            onInvalid={() => this.setState({ enabled: false })}>
            <FormInput
              label="Full name"
              type="text"
              size="large"
              name="full_name"
              placeholder="First and last name"
              validations="minLength:3"
              showErrorAfterBlur
              validationErrors={{
                minLength: 'Names should be at least 3 characters long.',
              }}
            />
            <FormInput
              label="Choose a password"
              type="password"
              autoComplete="new-password"
              className="UserPasswordForm-password"
              name="password"
              validations="minLength:6"
              validOnPristine
              validationError="Password must be at least 6 characters long."
            />
            <Button disabled={!this.state.enabled}>
              Submit
            </Button>
          </Form>
        </BoxBody>
      </DialogContent>
    );
  },
});

export default JoinEmailAccountUpgradeForm;



// WEBPACK FOOTER //
// ./src/join/components/JoinEmailAccountUpgradeForm.jsx